import Service from "@/helpers/py-service";

const state = {
  isLoading: false,
  streamsList: [],
  meta: {},
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_STREAMS(state, streamsList) {
    state.streamsList = streamsList;
  },
  SET_LOADING_LIST(state, value) {
    state.isLoading = value;
  },
};

const actions = {
  setLoadingValue: (store, value) => {
    store.commit("SET_LOADING_LIST", value);
  },
  list: (store, params) => {
    store.state.isLoading = true;
    return Service.get(`flespi/flespi-streams`, params)
      .then((data) => {
        store.commit("SET_STREAMS", data.body.data);
        store.commit("SET_META", data.body);
      })
      .finally(() => (store.state.isLoading = false));
  },

  streamSync: (store, params) => {
    store.state.isLoading = true;
    return Service.get(`flespi/flespi-streams/sync`, params)
      .then(() => {
        store.dispatch("list");
      })
      .finally(() => (store.state.isLoading = false));
  },
  bulkAssign: (store, params) => {
    store.state.isLoading = true;
    return Service.post(`flespi/assign-flespi-streams-to-tenant`, params)
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.isLoading = false));
  },
};

const getters = {
  getMeta(state) {
    return state.meta;
  },
  getStreamsList(state) {
    return state.streamsList;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

const motorTypes = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default motorTypes;
